import _ from 'lodash';
import React from 'react';
import { ExportDropdown } from '~/components';
import { mimeTypes } from '~/utils';

export default function ExportTasksAction({ projectKey, onExport }) {
  return (
    <ExportDropdown>
      {({ setIsOpen }) => (
        <>
          <ExportDropdown.Item
            onClick={async () => {
              await onExport(`${_.snakeCase(projectKey)}_tasks.csv`, mimeTypes.csv);
              setIsOpen(false);
            }}>
            Export to CSV
          </ExportDropdown.Item>

          <ExportDropdown.Item
            onClick={async () => {
              await onExport(`${_.snakeCase(projectKey)}_tasks.xlsx`, mimeTypes.xlsx);
              setIsOpen(false);
            }}>
            Export to Excel
          </ExportDropdown.Item>
        </>
      )}
    </ExportDropdown>
  );
}
